export default __webpack_public_path__ + "assets/images/9ed1ad53cc04b3636dbcca83962aeb02.svg";